import React, { useMemo } from "react";
import { useConfig } from "../../utils/context/configContext";

interface ProgressDotsProps {
  totalSteps: number;
  currentStepIndex: number;
}

const ProgressDots: React.FC<ProgressDotsProps> = ({ totalSteps, currentStepIndex }) => {
  const config = useConfig();
  const activeColor = config?.style?.base?.primaryColor || "#000";
  const inactiveColor = config?.style?.base?.secondaryColor || "#D9D9D9";

  const dots = useMemo(
    () =>
      Array.from({ length: totalSteps }, (_, i) => ({
        index: i,
        isActive: i === currentStepIndex,
        isCompleted: i < currentStepIndex
      })),
    [totalSteps, currentStepIndex]
  );

  return (
    <div className="flex justify-center items-center gap-[4px] my-[1.5rem]">
      {dots.map(({ index, isActive, isCompleted }) => (
        <div
          key={index}
          className={`h-[3px] rounded-[9999px] transition-all duration-300 ${
            isActive ? "w-[50px]" : "w-[30px]"
          }`}
          style={{
            backgroundColor: isCompleted || isActive ? activeColor : inactiveColor
          }}
        />
      ))}
    </div>
  );
};

export default ProgressDots;
